import { AttachmentModel } from '../attachment.model';
import { WorkflowModel } from '../workflows/workflow.model';
import { WorkflowPromotionStage } from '../workflowsPromotion/workflow-stage-promotion';
import { InvoicePPRLogModel } from './invoice-pprlog.model';

export class InvoiceModel {
  public Id: string;

  public Number: string;

  public State: string;

  public PrimaryReference: string;

  public SecondaryReference: string;

  public OcrDate: Date | string | null;

  public ImportDate: Date | string;

  public CreationDate: Date | string;

  public IssuedAt: Date | string | null;

  public DueDate?: Date | string | null;

  public EstimatedActDate?: Date | string | null;

  public AmountTaxExcluded: number | null;

  public AmountTaxIncluded: number | null;

  public Currency: string;

  public IsReverseFactoring: boolean;

  public IsWorkingSituation: boolean;

  public IsForPPRDirectInvoiceBDC: boolean;

  public CanProcessInvoice: boolean;

  public RecyclingFlag: string;

  public RejectionFlag: string;

  public RejectionFlagId: number;

  public InitialAssignmentGroupId: number | null;

  public InitialAssignmentGroupName: string;

  public InitialAssignmentAt: Date | string | null;

  public CurrentAssignmentGroupId: number | null;

  public CurrentAssignmentGroupName: string;

  public CurrentAssignmentAt: Date | string | null;

  public IsProcessed: boolean;

  public ProcessedAt: Date | string | null;

  public ProcessedByUserId: string;

  public TypeId: number;

  public TypeName: string;

  public SupplierMdmId: number | null;

  public SupplierSiren: string;

  public SupplierSiret: string;

  public SupplierCompanyName: string;

  public SupplierEvaluaCompanyName: string;

  public SupplierComputedCompanyName: string;

  public SupplierVatNumber: string;

  public SupplierRcsNumber: string;

  public SupplierAddress: string;

  public SupplierEmail: string;

  public SupplierHasWarning: boolean;

  public SupplierRecipientName: string;

  public RecipientEntityName: string;

  public RecipientEntityId?: number;

  public CurrentAssignmentGroupSupervisorId: string;

  public CurrentAssignmentGroupSupervisorName: string;

  public Referent: string;

  public IsCompleted: boolean | null;

  public IsVoucher: boolean | null;

  public IsPPR: boolean | null;

  public IsVoucherValidated: boolean | null;

  public IsWorkflowBAP: boolean | null;

  public WorkflowIsCompleted: boolean | null;

  public WorkflowIsActive: boolean | null;

  public VoucherDepartment: string;

  public VoucherAnalyticalSection: string;

  public VoucherAnalyticalCode: string;

  public VoucherComment: string;

  public PickedAt: Date | null;

  public PickedByUserId: string;

  public PickedByUser: string;

  public ComplaintAt: Date | null;

  public ComplaintByUserId: string;

  public ComplaintByUser: string;

  public ComplaintComment: string;

  public IsComplaint: boolean | null;

  public IsReturnOperationalComment: boolean | null;

  public ShouldBeChecked: boolean | null;

  public Checked: boolean;

  public CheckedByUser: string;

  public CheckedAt: Date | null;

  public VoucherValidatedAt: Date | string | null;

  public WorkflowCompletionDate: Date | string | null;

  public Attachments: Array<AttachmentModel>;

  public Workflow: WorkflowModel;

  public SupplierSageErpCode: string | null;

  public OperationAssistantName: string | null;

  public InvoicePPRLogs: Array<InvoicePPRLogModel>;

  public InvoiceLastPPRLog: string | null;

  public InvoicePPRLogsErrorCount: number;

  public WaitingFlag: string;

  public WaitingFlagId: number;

  public ErrorPPRType: string | null;

  public ErrorPPRUserName: string | null;

  public StepworkflowStageLevel: number | null;

  public clePPM: string | null;

  public InvoicePPRId: string | null;

  public CommentReturnOperationnal: string | null;

  public CommentReturnFirstLevel: string | null;

  public WorkflowPromotionCurrentStage: WorkflowPromotionStage;

  public CumulationPreviousSituationAmountTaxExcluded: number | null;

  public WorkSituationAmountTaxExcluded: number | null;

  public CumulationPreviousSituationSetByUser: string;

  public CumulationPreviousSituationSetByUserId: string;

  public CumulationPreviousSituationSetAt: Date | null;

  public PaidDate: Date | null;

  public TradeCode: string | null;

  public TradeLabel: string | null;
  
  public TradeCodeLabel: string | null;
  
  public FamilyCode: string | null;

  public FamilyLabel: string | null;
}
